import { render } from "./MultilangInput.vue?vue&type=template&id=0bb63329"
import script from "./MultilangInput.vue?vue&type=script&lang=js"
export * from "./MultilangInput.vue?vue&type=script&lang=js"

import "./MultilangInput.vue?vue&type=style&index=0&id=0bb63329&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__